import React, { useState } from 'react';
import styled from 'styled-components';

const PASSWORD = 'walle';
const STORAGE_KEY = 'portfolio-password-unlocked';

const Screen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--bg);
  color: var(--text);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  max-width: 16rem;
`;

const Label = styled.label`
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.01em;
`;

const Input = styled.input`
  width: 100%;
  font-family: var(--font-sans);
  font-size: 16px;
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg);
  color: var(--text);
  text-align: center;

  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 2px;
  }
`;

const Submit = styled.button`
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--bg);
  background: var(--text);
  padding: 0.55rem 1.35rem;
  border-radius: 12px;

  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 3px;
  }
`;

const ErrorText = styled.p`
  margin: 0;
  min-height: 1.25em;
  font-family: var(--font-serif);
  font-size: 16px;
  color: var(--text-muted);
`;

const isUnlocked = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(isUnlocked);
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value.trim() === PASSWORD) {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } catch {
        // Private browsing can block storage; still unlock this visit.
      }
      setUnlocked(true);
      return;
    }
    setError('Incorrect password');
  };

  if (unlocked) return children;

  return (
    <Screen>
      <Form onSubmit={handleSubmit}>
        <Label htmlFor="site-password">Password</Label>
        <Input
          id="site-password"
          type="password"
          autoFocus
          autoComplete="current-password"
          value={value}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error ? 'site-password-error' : undefined}
          onChange={(event) => {
            setValue(event.target.value);
            if (error) setError('');
          }}
        />
        <Submit type="submit">Enter</Submit>
        <ErrorText id="site-password-error" role="alert">
          {error}
        </ErrorText>
      </Form>
    </Screen>
  );
};

export default PasswordGate;
